import { useState } from "react";
import { Col, InputGroup, Form, Button } from "react-bootstrap";
import { useFormik } from "formik";
import * as Yup from "yup";

/*
    The rules are the server's (MPN-1778).

    Only the minimum length is mirrored here. Django applies four validators inside
    `AppUser.set_password` -- length, common passwords, all-numeric, and similarity to the
    user's own email -- and the last three cannot be reproduced faithfully in the browser.
    Half-copying them would either reject something the server accepts or promise something
    it refuses, so the rest arrive as the server's own message when it answers.

    Length is worth catching here because it is the one a person can fix before pressing
    anything, and it was the likeliest cause of the original report.
*/
const SERVER_MINIMUM_LENGTH = 8;

export default function PasswordForm(
    { sendFormData, isSaving = false }:
    { sendFormData: (password: string) => void; isSaving?: boolean },
) {
    const [currentForm] = useState({ password: '', confirmPassword: '' });
    const [passwordshow1, setpasswordshow1] = useState(false);
    const [passwordshow2, setpasswordshow2] = useState(false);

    const schemaValidation = Yup.object().shape({
        password: Yup.string()
            .required("Password is required")
            .min(SERVER_MINIMUM_LENGTH,
                 `Password must be at least ${SERVER_MINIMUM_LENGTH} characters`),
        confirmPassword: Yup.string().required("Confirm Password is required").oneOf([Yup.ref('password')], 'Passwords must match'),
      });

    const formikInstance = useFormik({
        initialValues: currentForm,
        enableReinitialize: true,
        validationSchema: schemaValidation,
        onSubmit: async (formState: any) => {
            sendFormData(formState.password);
        }
      });
    
    return (
        <Form onSubmit={formikInstance.handleSubmit}>
        <div className="row gy-3">
            <Col xl={12}>
                <Form.Label htmlFor="create-password" className="form-label text-default">Password</Form.Label>
                <InputGroup>
                <Form.Control 
                    id="create-password"
                    name="password"
                    type={(passwordshow1) ? 'text' : "password"}
                    className="form-control-lg"
                    placeholder="password"
                    value={formikInstance.values.password}
                    onChange={formikInstance.handleChange}
                    onBlur={formikInstance.handleBlur}
                    isInvalid={!!(formikInstance.touched.password && formikInstance.errors.password)}
                />
                    <Button variant='' className="btn btn-light" type="button" onClick={()=>setpasswordshow1(!passwordshow1)}
                    ><i className={`${passwordshow1 ? 'ri-eye-line' : 'ri-eye-off-line'} align-middle`} aria-hidden="true"></i></Button>
                    <Form.Control.Feedback type="invalid">
                        {formikInstance.errors.password}
                    </Form.Control.Feedback>
                </InputGroup>
            </Col>
            <Col xl={12} className=" mb-2">
                <label htmlFor="create-confirmpassword" className="form-label text-default">Confirm Password</label>
                <InputGroup>
                    <Form.Control 
                        id="create-confirmpassword"
                        name="confirmPassword"
                        type={(passwordshow2) ? 'text' : "password"}
                        className="form-control-lg"
                        placeholder="password"
                        value={formikInstance.values.confirmPassword}
                        onChange={formikInstance.handleChange}
                        onBlur={formikInstance.handleBlur}
                        isInvalid={!!(formikInstance.touched.confirmPassword && formikInstance.errors.confirmPassword)}
                    />
                    <Button variant='' className="btn btn-light" type="button" onClick={()=>setpasswordshow2(!passwordshow2)}
                    ><i className={`${passwordshow2 ? 'ri-eye-line' : 'ri-eye-off-line'} align-middle`} aria-hidden="true"></i></Button>
                    <Form.Control.Feedback type="invalid">
                        {formikInstance.errors.confirmPassword}
                    </Form.Control.Feedback>
                </InputGroup>
            </Col>
            <Col xl={12} className=" d-grid mt-2">
                {/* Disabled only while the request is in flight. Anything stricter would
                    reproduce the original bug in a new form: a button that looks broken
                    because a rule it does not explain is failing. */}
                <Button type="submit" variant='primary' className="btn btn-lg" disabled={isSaving}>
                    {isSaving ? "Changing Password..." : "Change Password"}
                </Button>
            </Col>
        </div>
    </Form>
    )
}